import { handleFreeTrialStart } from '@src/state/payment/actions'
import { AuthActions, GlobalActions, PaymentActions } from '@src/types/actions'
import { getType } from 'typesafe-actions'
import { resetState } from '../actions'
import { hideCheggAuthModal } from '../auth/actions'

export interface PaymentState {
  showPaywallOnLogin: boolean
}

export const initialState: PaymentState = {
  showPaywallOnLogin: false,
}

const paymentReducer = (
  state: PaymentState = initialState,
  action: PaymentActions | AuthActions | GlobalActions
) => {
  switch (action.type) {
    case getType(handleFreeTrialStart): {
      return {
        showPaywallOnLogin: true,
      }
    }
    case getType(hideCheggAuthModal): {
      return {
        showPaywallOnLogin: false,
      }
    }
    case getType(resetState): {
      return initialState
    }
    default:
      return state
  }
}

export default paymentReducer



// WEBPACK FOOTER //
// ./src/state/payment/reducer.ts